import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

// API Configuration
export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Transport Expense Categories
export const TRANSPORT_EXPENSE_CATEGORIES = [
  { id: 'tell', name: 'Tell (Fuel)', icon: 'Fuel' },
  { id: 'driver_salary', name: 'Driver Salary', icon: 'User' },
  { id: 'co_driver_salary', name: 'Co-Driver Salary', icon: 'User' },
  { id: 'kisti', name: 'Kisti (EMI)', icon: 'CreditCard' },
  { id: 'paper', name: 'Paper (RTO)', icon: 'FileCheck' },
  { id: 'toll', name: 'Toll', icon: 'CircleDollarSign' },
  { id: 'other', name: 'Other', icon: 'Receipt' }
];

// Format currency in Indian format
export const formatCurrency = (amount) => {
  const num = parseFloat(amount) || 0;
  return new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency: 'INR',
    maximumFractionDigits: 0
  }).format(num);
};

// Format date
export const formatDate = (dateString) => {
  if (!dateString) return '';
  const date = new Date(dateString);
  return date.toLocaleDateString('en-IN', {
    day: '2-digit',
    month: 'short',
    year: 'numeric'
  });
};

// Format time
export const formatTime = (dateString) => {
  if (!dateString) return '';
  const date = new Date(dateString);
  return date.toLocaleTimeString('en-IN', {
    hour: '2-digit',
    minute: '2-digit'
  });
};

// Format currency for print (without symbol issues)
export const formatPrintCurrency = (amount) => {
  return 'Rs. ' + new Intl.NumberFormat('en-IN', {
    maximumFractionDigits: 0
  }).format(amount || 0);
};

// Format date for print
export const formatPrintDate = (dateStr) => {
  const date = new Date(dateStr);
  return date.toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' });
};
